<template>
  <div class="me-1" id="switch">  
    <notification-talk-button />
    <notification-talk-area />
  </div>
</template>

<script>
import NotificationTalkButton from '@/views/atoms/NotificationTalkButton'
import NotificationTalkArea from '@/views/templates/NotificationTalkArea'
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'

export default {
  name: "NotificationTalkBrowseItem",
  components: {
    NotificationTalkButton,
    NotificationTalkArea,
  },
  mixins: [AddonLoadPageEvent],
  inject: [
    '$constant',
  ],
  data() {
    return {
      timer: '',
    }
  },
  methods: {
    loadTalkNotice() {
      sessionStorage.setItem('hideApiLoading', 'true');
      this.$store.dispatch('talk_notifieds/load').then(() => {

      }).catch(reason => {
        this.$root.failApi(reason);
      }).finally(() => {
        sessionStorage.removeItem('hideApiLoading');
      });
    },
    cancelLoadTalkNotice () {
      clearInterval(this.timer);
    },
  },
  mounted () {
    setTimeout(() => { 
      this.loadTalkNotice();
    }, 5000);
    this.timer = setInterval(() => {
      this.loadTalkNotice();
    }, this.$constant.INTERVAL_DELAY.MINUTE * 1000 * 60);
  },
  beforeUnmount () {
    this.cancelLoadTalkNotice();
  },
}
</script>